import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis } from "./SmoothScroll";

// Every route change opens the new page at the top (in-page #anchors are left alone).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    const lenis = getLenis();
    // Jump Lenis too, or its eased position would pull the new page back down.
    if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
